import React, { useEffect } from 'react';
import { oneOf } from 'prop-types';

import useValueRef from '../../hooks/useValueRef';

const InpostGeowidget = ({ id, token, language, config, onPointSelect }) => {
  const onPoint = `${id ? `${id}_` : ''}inpost_onpoint`;
  const onPointSelectRef = useValueRef(onPointSelect);

  useEffect(() => {
    window[onPoint] = (...args) => {
      onPointSelectRef.current?.(...args);
    };

    return () => {
      delete window[onPoint];
    };
  }, [onPoint]);

  if (!token) {
    return <div>InPost Geowidget Token Missing</div>;
  }

  return React.createElement('inpost-geowidget', {
    id,
    token,
    language,
    config,
    onPoint,
  });
};

InpostGeowidget.defaultProps = {
  language: 'pl',
  config: 'parcelCollect',
};

InpostGeowidget.propTypes = {
  language: oneOf(['pl', 'en', 'uk']),
  config: oneOf([
    /**
     * Display collection points for prepaid orders:
     * - Parcel Locker
     * - ParcelPoint
     */
    'parcelCollect',
    /**
     * Display collection points for cash on delivery orders:
     * - Parcel Locker
     * - ParcelPoint
     */
    'parcelCollectPayment',
    /**
     * Display collection points for Weekend shipments:
     * - Parcel lockers
     * - ParcePoints available 24/7
     */
    'parcelCollect247',
    /**
     * Showing sending points:
     * - Parcel Locker
     * - ParcelPoint
     */
    'parcelSend',
  ]),
};

export default InpostGeowidget;
